export default page => ({
  type: 'CHANGE_REGISTRATION_PAGE',
  page,
});



// WEBPACK FOOTER //
// ./src/Actions/Register/changePage.js